<template>
  <div id="app">
    <notifications classes="notifications" position="top center" />
    <template v-if="user.loggedIn">
      <template v-if="user.data !== null">
        <template v-if="user.data.emailVerified === true">
          <div v-if="user.data.firestore.suspended">
            <p>
              Your account has been suspeneded. If you think this is a mistake then please contact someone from TrafficLab.
            </p>
          </div>
          <div v-else>
            <nav>
              <template v-if="user.data.firestore.isAdmin">
                <router-link to="/freelancers">Freelancers</router-link>
                <router-link to="/task/new" data-cy="new-task">New Task</router-link>
                <router-link to="/overview/review">Review</router-link>
                <router-link to="/overview/seo">SEO</router-link>
                <router-link to="/overview/linkbuilding">Link Building</router-link>
                <router-link to="/overview/chatterbox">Chatterbox</router-link>
                <div class="dropdown">
                  <span>Old content</span>
                  <div class="dropdown-content">
                    <router-link to="/approvals/review">Reviews</router-link>
                    <router-link to="/approvals/seo">SEO Articles</router-link>
                    <router-link to="/approvals/linkbuilding">Link Building</router-link>
                    <router-link to="/approvals/chatterbox">Chatterbox</router-link>
                  </div>
                </div>
              </template>
              <template v-else>
                <router-link to="/" data-cy="my-tasks">My Tasks</router-link>
                <router-link to="/tasks" data-cy="available-tasks">Available Tasks</router-link>
                <router-link class="dropdown" to="/content" data-cy="deprecated">Content (Depricated)</router-link>
                <!-- <router-link to="/content/new/review">New Review</router-link>
                <router-link to="/content/new/seo">New SEO Article</router-link>
                <router-link to="/linkbuilding/new">New Link Building Text</router-link> -->
                <!-- <router-link to="/chatterbox/new">New Chatterbox Text</router-link> -->
              </template>
              <div class="user">
                <span>{{ userName }}</span>
                <!-- prettier-ignore -->
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24"><path d="M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6z" fill="#999" /></svg>
                <!-- prettier-ignore -->
                <svg xmlns="http://www.w3.org/2000/svg" width="38" height="38" viewBox="0 0 24 24"><path fill="#F5F6FA" d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 3c1.66 0 3 1.34 3 3s-1.34 3-3 3-3-1.34-3-3 1.34-3 3-3zm0 14.2c-2.5 0-4.71-1.28-6-3.22.03-1.99 4-3.08 6-3.08 1.99 0 5.97 1.09 6 3.08-1.29 1.94-3.5 3.22-6 3.22z"/><path d="M0 0h24v24H0z" fill="none" /></svg>
                <div class="user__dropdown">
                  <router-link class="user__dropdown-item" to="/profile">Settings</router-link>
                  <span class="user__dropdown-item" data-cy="logout-button" @click="signOut">Sign out</span>
                </div>
              </div>
            </nav>
            <router-view />
          </div>
        </template>
        <div v-else>
          <p>
            Please verify your email. Refresh this page after you verified your email.
          </p>
          <p>
            If you entered a wrong email, then you can
            <button @click="signOut">logout</button> and try again.
          </p>
        </div>
      </template>
    </template>
    <div v-else>
      <div id="firebaseui-auth-container" v-bind:class="{ hidden: user.isFetching }"></div>
    </div>
  </div>
</template>

<script>
import firebase from 'firebase'
import * as firebaseui from 'firebaseui'
import { mapGetters, mapActions } from 'vuex'

export default {
  methods: {
    ...mapActions(['fetchBrands', 'fetchLinkBuilderAdminList']),
    signOut() {
      firebase
        .auth()
        .signOut()
        .then(() => {
          window.location.reload()
        })
    },
    startFirebaseAuthContainer() {
      var uiConfig = {
        credentialHelper: firebaseui.auth.CredentialHelper.NONE,
        signInSuccessUrl: '/',
        signInOptions: [firebase.auth.EmailAuthProvider.PROVIDER_ID],
        tosUrl: '/terms-of-serice',
        // Privacy policy url/callback.
        privacyPolicyUrl: function() {
          window.location.assign('/privacy')
        },
      }
      // Initialize the FirebaseUI Widget using Firebase.
      var ui = new firebaseui.auth.AuthUI(firebase.auth())
      // The start method will wait until the DOM is loaded.
      ui.start('#firebaseui-auth-container', uiConfig)
    },
  },
  computed: {
    ...mapGetters(['user']),
    userName() {
      return this.user.data.firestore.name ? this.user.data.firestore.name : 'No username'
    },
  },
  async created() {
    this.startFirebaseAuthContainer()
    await this.fetchBrands()
    this.fetchLinkBuilderAdminList()
  },
}
</script>

<style lang="scss">
:root {
  --color-cta: #4f8ae8;
  --color-cta-hover: #4381e6;
  --color-state: #a39ffb;
  --color-danger: #de7d7d;

  --border-radius-large: 2rem;
  --border-radius-small: 0.25rem;
}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  scroll-behavior: smooth;
  color: #43425d;
}
body {
  margin: 0;
  background-color: #f0f0f7;
}
h1 {
  margin: 0;
  font-weight: 400;
  font-size: 1.5rem;
}
h2 {
  margin: 0;
  font-weight: 400;
  font-size: 1.35rem;
}
nav {
  position: relative;
  display: flex;
  align-items: center;
  background: white;
  padding: 1rem 3rem;
  min-height: 70px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.04);
  box-sizing: border-box;
  > a {
    text-decoration: none;
    color: #4d4f5c;
    margin-right: 2rem;
    &:hover {
      color: var(--color-state);
    }
    &.router-link-exact-active {
      color: var(--color-state);
      font-weight: bold;
    }
  }
  button {
    background-color: inherit;
    border-style: inherit;
    font-size: inherit;
    cursor: pointer;
  }
  .user {
    display: flex;
    align-items: center;
    position: relative;
    padding-left: 1rem;
    border-left: 1px solid #ebebf2;
    cursor: pointer;
    a,
    span {
      font-size: 0.8125rem;
    }
    svg {
      margin-left: 0.55rem;
    }
    .user__dropdown {
      display: none;
      position: absolute;
      margin: 0;
      overflow: hidden;
      background-color: white;
      z-index: 1;
      box-shadow: 0 2px 10px rgba(0, 0, 0, 0.15);
      min-width: 180px;
      top: calc(100%);
      & .user__dropdown-item {
        display: flex;
        border-bottom: 1px solid #f1f1f3;
        padding: 0.5rem 1rem;
        margin-right: 0;
        color: #4d4f5c;
        text-decoration: none;
        cursor: pointer;
        &:hover {
          background-color: #fafafc;
        }
      }
    }
    &:hover .user__dropdown {
      display: block;
    }
  }
}
.dropdown {
  margin-right: 2rem;
  margin-left: auto;
  cursor: pointer;
}
.dropdown-content {
  display: none;
  position: absolute;
  background: white;
  margin: 0;
  overflow: hidden;
  min-width: 120px;
  z-index: 1;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.15);
}
.dropdown-content > a {
  display: flex;
  border-bottom: 1px solid #f1f1f3;
  padding: 0.5rem 1rem;
  margin-right: 0;
  color: #4d4f5c;
  cursor: pointer;
  text-decoration: none;
  &:hover {
    background-color: #fafafc;
  }
}
.dropdown:hover .dropdown-content {
  display: flex;
  flex-direction: column;
}
.content-wrapper {
  position: relative;
  display: grid;
  gap: 1.5rem;
  grid-template-rows: auto 1fr;
  align-items: start;
  padding: 2rem 3rem;
  min-height: calc(100vh - 70px);
  grid-template-columns: auto;
  box-sizing: border-box;
}
.hidden {
  display: none;
}
.notifications {
  padding: 10px;
  margin: 0.5rem 0 0.1rem 0.1rem;
  font-size: 12px;
  width: 100%;
  color: #ffffff;
  background: #44a4fc;
  border-left: 5px solid #187fe7;
  &.warn {
    background: #ffb648;
    border-left-color: #f48a06;
  }
  &.error {
    background: #e54d42;
    border-left-color: #b82e24;
  }
  &.success {
    background: #68cd86;
    border-left-color: #42a85f;
  }
}
.tabs {
  background: none;
  box-shadow: none;
  padding: 0;
  min-height: auto;
}
.tabs__item {
  cursor: pointer;
  border: 1px solid #e9e9f0;
  font-size: 0.75rem;
  padding: 0.5rem 1rem;
  border-radius: 0 0.25rem 0.25rem 0;
  background: white;
  outline: none;
  font-family: inherit;
  color: inherit;
  min-width: 80px;
}
.tabs__item:hover {
  background-color: #f1f1f3;
}
.tabs__item:hover.tabs__item_active {
  background-color: var(--color-state);
}
.tabs__item:first-of-type {
  border-radius: 0.25rem 0 0 0.25rem;
}
.tabs__item_active {
  background-color: var(--color-state);
  font-weight: 700;
  border: 1px solid var(--color-state);
  color: white;
}
.mdl-js .dg-backdrop {
  background-color: rgba(0, 0, 0, 0.7);
}
.mdl-js .dg-main-content {
  border-radius: 0.25rem;
  padding: 0;
  overflow: hidden;
  background-color: transparent;
  width: 300px;
}
.mdl-js .dg-content-cont {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  color: #43425d;
}
.mdl-js .dg-content-body {
  border-bottom: none;
  padding-bottom: 0rem;
}
.mdl-js .dg-content {
  line-height: normal;
  padding: 1.5rem;
  background: white;
}
.mdl-js .dg-content-footer {
  display: flex;
  padding: 0;
}
.mdl-js .dg-btn {
  border: none;
  font-weight: 400;
  font-size: 0.8125rem;
  font-family: Avenir, Helvetica, Arial, sans-serif;
  border-radius: 0;
  padding: 0.75rem 2rem;
  width: 100%;
}
.mdl-js .dg-btn--cancel {
  background-color: #43425d;
}
.mdl-js .dg-btn--ok {
  background-color: var(--color-cta);
  color: white;
}
.mdl-js .vue__time-picker input.display-time {
  width: 100%;
  font-family: Avenir, Helvetica, Arial, sans-serif;
  font-size: 0.8125rem;
  padding: 0.5rem 3rem 0.5rem 0.5rem;
  border-radius: 0.25rem;
  border: 1px solid #e9e9f0;
  background-color: #fafafc;
  outline: none;
}

.mdl-js .vue__time-picker input.display-time::placeholder {
  color: transparent;
}

.mdl-js .vue__time-picker .dropdown .hint {
  color: #a5a5a5;
}

.mdl-js .vue__time-picker .dropdown ul li {
  color: #43425d;
}

.mdl-js .vue__time-picker .dropdown ul li:not([disabled]).active,
.vue__time-picker .dropdown ul li:not([disabled]).active:focus,
.vue__time-picker .dropdown ul li:not([disabled]).active:hover {
  background: var(--color-cta) !important;
}

.mdl-js .vue__time-picker .dropdown {
  border-radius: 0.25rem;
}

// Custom login styles
#firebaseui-auth-container {
  height: 100vh;
  display: flex;
}

.firebaseui-container {
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.04);
  font-family: Avenir, Helvetica, Arial, sans-serif;
  margin: auto;
}

.firebaseui-title,
.firebaseui-subtitle {
  color: #43425d;
}

.mdl-button {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  font-weight: 600;
  text-transform: capitalize;
}
.mdl-button--raised.mdl-button--colored {
  background-color: var(--color-cta);
  border-radius: 0.25rem;
}
.mdl-button--raised.mdl-button--colored:hover {
  background-color: var(--color-cta-hover);
}
.mdl-button--primary.mdl-button--primary {
  color: var(--color-state);
}
.mdl-button--raised {
  box-shadow: none;
}
.mdl-textfield__input {
  font-family: Avenir, Helvetica, Arial, sans-serif;
}

// Datetime styling
.vdatetime-input {
  color: #43425d;
}

.vdatetime-popup__header {
  color: var(--color-cta);
}
.vdatetime-calendar__month__day--selected > span > span,
.vdatetime-calendar__month__day--selected:hover > span > span {
  background: var(--color-cta) !important;
}

div.vdatetime-popup__actions__button {
  color: var(--color-cta);
}

div.vdatetime-time-picker__item--selected {
  color: var(--color-cta);
}
</style>
